/* unplugin-vue-components disabled */import { render } from "./ImageBox.vue?vue&type=template&id=517dd052&ts=true"
import script from "./ImageBox.vue?vue&type=script&lang=ts"
export * from "./ImageBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__